import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { SetUserPasswordDialog } from "../Ui/Dialogs/SetUserPasswordDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandUserSetPasswordPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandUserSetPasswordProperties = {
    [name in keyof EntityCommandUserSetPasswordPropertyValues]: Property<EntityCommandUserSetPasswordPropertyValues[name]>
};

export interface IEntityCommandUserSetPassword extends IEntityCommand, EntityCommandUserSetPasswordProperties
{
}

export class EntityCommandUserSetPassword extends EntityCommand implements IEntityCommandUserSetPassword
{
    // #region Static

    // #region Properties

    public static override classNamespace = NAMESPACE + "EntityCommandUserSetPassword";
    public static override className = "EntityCommandUserSetPassword";

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandUserSetPasswordPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Set Password",
                entityName: "User",
                key: "SET_PASSWORD",
                permission: PermissionEvaluator.permissionLevels.update,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected setUserPasswordDialog?: SetUserPasswordDialog;

    // #endregion

    // #region Constructors

    constructor(propertyValues?: PartialNullable<EntityCommandUserSetPasswordPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        const
            self = this;

        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        record = entityCommandInformation.record.get();

                    if (!record || !record.id)
                        return;

                    if (!self.setUserPasswordDialog)
                        self.setUserPasswordDialog = new SetUserPasswordDialog();

                    const
                        promise =
                            self.setUserPasswordDialog.openAsync(record.id)
                                .then(result =>
                                {
                                    if (result.dialogResult !== DialogResultEnum.ok)
                                        return;

                                    MessageDialog.displayMessage("User Password Set", "The users password has been set");
                                });

                    self.setUserPasswordDialog.dataSource.set(new DataSource({ data: {} })); // Set data source after open

                    return promise;
                })
        );
    }

    // #endregion

    // #endregion
}

